import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => {
    const STATUS_COLORS = {
        listed: { background: '#E7F6EC', text: '#0A6B33', dot: '#12B76A' },
        notListed: { background: '#F2F4F7', text: theme.palette.text.secondary, dot: '#98A2B3' },
        noPrimary: {
            background: '#FEECEC',
            text: theme.palette.secondary.main,
            dot: theme.palette.secondary.main,
        },
    };

    return {
        card: {
            backgroundColor: '#ffffff',
            border: '1px solid #E4E7EC',
            borderRadius: 8,
            padding: '44px 48px',
        },
        headingRow: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 16,
            marginBottom: 8,
        },
        heading: {
            letterSpacing: '-0.01em',
        },
        // discoverableToggleCard.jsx shares this stylesheet with no status prop.
        statusBadge: ({ status = 'notListed' }) => ({
            height: 'auto',
            padding: '6px 13px',
            borderRadius: 20,
            fontSize: 12.5,
            fontWeight: 600,
            letterSpacing: '.02em',
            backgroundColor: STATUS_COLORS[status].background,
            // !important: Chip wrapper hardcodes color: 'white', overriding this.
            color: `${STATUS_COLORS[status].text} !important`,
        }),
        statusDot: ({ status = 'notListed' }) => ({
            display: 'inline-block',
            verticalAlign: 'middle',
            width: 7,
            height: 7,
            marginRight: 8,
            borderRadius: '50%',
            backgroundColor: STATUS_COLORS[status].dot,
        }),
        statusText: {
            position: 'relative',
            top: 1,
        },
        description: {
            color: theme.palette.text.secondary,
            marginBottom: 16,
            maxWidth: '90ch',
        },
        toggleCard: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 24,
            border: '1px solid #E4E7EC',
            borderRadius: 8,
            padding: '24px 26px',
            marginBottom: 30,
        },
        toggleTitle: {
            fontWeight: 600,
            marginBottom: 6,
        },
        toggleDescription: {
            color: theme.palette.text.secondary,
        },
    };
});
